<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3 d-flex flex-wrap align-items-center gap-3">
              <h5 class="mb-0">GL Account List</h5>
              <div class="d-flex flex-wrap gap-2 flex-grow-1 justify-content-center">
                <IconField class="search-field">
                  <InputIcon>
                    <i class="pi pi-search" />
                  </InputIcon>
                  <InputText
v-model="table.search" type="text" size="small" placeholder="Search GL Account"
                    class="rounded-pill" style="min-width: 500px;" @keyup="filter" />
                </IconField>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table" style="min-width: 100%; width: max-content;">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      GL Account Number
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">
                      GL Account Description
                    </th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder text-center w-1">
                      Created At
                    </th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="type in table.data" :key="type.id">
                    <td class="text-sm py-3 px-4 value-table-wrapped" style="max-width: 6cm">
                      <div>{{ type.gl_account_number }}</div>
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped" style="max-width: 10cm">
                      <div>{{ type.gl_account_description }}</div>
                    </td>
                    <td class="text-sm py-3 px-4 value-table-wrapped" style="max-width: 10cm">
                      <div>{{ formatDate(type.created_at) }}</div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="3">No Data</td>
                  </tr>
                </tbody>
              </table>

              <SkeletonLoading
v-else class="px-4 pt-5" :shapes="[
                { type: 'line', width: '100%', height: '20px' },
                { type: 'line', width: '80%', height: '20px' },
                { type: 'line', width: '60%', height: '20px' },
              ]" />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
v-model="table.page.current_pages" :page-count="table.page.total_pages" size="sm"
                  @click="changePage()" />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from "@/helpers/api";
import glAccountService from "@/services/generalMasterData/glAccountService"; // Sesuaikan dengan path service

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: true,
        search: this.$route.query.code || "", // Mengambil nilai pencarian dari query
        total: 0,
        data: [],
        page: {
          current_pages: 1,
          per_pages: 100, // Tambahkan sesuai kebutuhan
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(
          this,
          glAccountService.list(this.table.page.current_pages, {
            code: this.table.search,
          }),
          false
        );

        this.table.data = response.data.data;
        this.table.total = response.data.total_items;
        this.table.page = response.data;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.updateQuery(); // Memperbarui URL
        this.get();
      }, 300);
    },
    updateQuery() {
      this.$router.push({ query: { code: this.table.search } });
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
